import React from "react";

import { Text } from "@performyard/py-components";

import AvatarGroup from "../../../../components/AvatarGroup";

import { config } from "../config";

type PageHeaderProps = {
	workspaceName: string;
	participants: Array<{ _id: string; name: string }>;
};

const PageHeader = ({ workspaceName, participants }: PageHeaderProps): React.ReactElement => {
	return (
		<div className="flex w-full flex-row items-center space-x-2 py-6">
			<div className="py-line-clamp-1" style={{ maxWidth: config.layout.pageHeaderMaxWidth }}>
				<Text size="heading-5" weight="semi-bold">
					{workspaceName}
				</Text>
			</div>
			<AvatarGroup employees={participants} maxLength={2} size={32} employeeNameTooltip={true} />
		</div>
	);
};

export default PageHeader;
